import { DatePickerLunarProps } from "@/components/datepicker/datepicker.types.ts";
import { useDatepickerConfig } from "@/hooks/use-datepicker-config.hook.ts";
import { DatepickerCore } from "@skailer-com/uikit";
import { forwardRef, Ref } from "react";

export const Datepicker = forwardRef((props: DatePickerLunarProps, ref: Ref<HTMLDivElement>) => {
  const datepickerConfig = useDatepickerConfig();

  return <DatepickerCore {...props} {...datepickerConfig} ref={ref} />;
});
